import { Controller } from "stimulus"

export default class extends Controller {
  static classes = ["open"];
  static targets = ["locale"]
  menuOpen() {
    this.element.classList.toggle(this.openClass);
  }
  changeLanguage(){
    const url = new URL(window.location)
    const searchParams = url.searchParams
    searchParams.set("locale",this.localeTarget.value)
    url.search = searchParams.toString()
    location.href = url.toString()
  }
}
